<template>
  <div>
    <h3 class="page-title title-slash invoice-info-title">
      {{ $t('invoices.single.info.title') }}
    </h3>
    <table class="table invoice-info-table">
      <tr>
        <th>{{ $t('invoices.single.info.reference') }}</th>
        <td class="text-right">{{ invoice.reference }}</td>
      </tr>
      <tr>
        <th>{{ $t('invoices.single.info.seller') }}</th>
        <td class="text-right">
          {{ invoice.exporter.company || invoice.exporter }}
        </td>
      </tr>
      <tr>
        <th>{{ $t('invoices.single.info.buyer') }}</th>
        <td class="text-right">{{ invoice.importer }}</td>
      </tr>
      <tr>
        <th>{{ $t('invoices.single.info.invoiceValue') }}</th>
        <td class="text-right">
          {{ invoice.value | currency(invoice.currsym) }}
        </td>
      </tr>
      <tr>
        <th>{{ $t('invoices.single.info.containerNumber') }}</th>
        <td class="text-right">{{ invoice.container || 'N/A' }}</td>
      </tr>
      <tr>
        <th>{{ $t('invoices.single.info.blDate') }}</th>
        <td class="text-right">
          {{ (invoice.bl_date || 'N/A') | moment('MMMM D, YYYY') }}
        </td>
      </tr>
      <tr>
        <th>{{ $t('invoices.single.info.paymentTerms') }}</th>
        <td class="text-right">
          {{ invoice.plan ? invoice.plan.payment_terms : '' }}
        </td>
      </tr>
      <tr>
        <th>{{ $t('invoices.single.info.dueDate') }}</th>
        <td class="text-right">
          {{
            invoice.repayment || invoice.user_due_date | moment('MMMM D, YYYY')
          }}
        </td>
      </tr>
      <tr>
        <th>{{ $t('invoices.single.info.poNo') }}</th>
        <td class="text-right" v-if="!!this.$store.state.account.accountId">
          {{ invoice.po_no || 'N/A' }}
        </td>
        <td class="text-right" v-else>{{ invoice.po_no || 'N/A' }}</td>
      </tr>
      <tr>
        <th>{{ $t('invoices.single.info.poDate') }}</th>
        <td class="text-right">
          {{ (invoice.po_date || 'N/A') | moment('MMMM D, YYYY') }}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: ['invoice']
}
</script>
